import BaseModule from './BaseModule';
import Factory from "../libs/Factory";
import {requireElement} from "../libs/Helpers";

export default class Counter extends BaseModule {
  constructor(el: HTMLElement, factory: Factory) {
    super(el, factory, 'Counter');

    const input = requireElement<HTMLInputElement>(el, '.counter-input');

    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    const btnDecrease = requireElement<HTMLButtonElement>(el,'.counter-decrease');
    btnDecrease.addEventListener('click', function (e) {
      e.preventDefault();

      let val = Number(input.value);
      val--;
      val = val >= min ? val : min;
      input.value = val.toString();
    });

    const btnIncrease = requireElement<HTMLButtonElement>(el,'.counter-increase');
    btnIncrease.addEventListener('click', function (e) {
      e.preventDefault();

      let val = Number(input.value);
      val++;
      val = val <= max ? val : max;
      input.value = val.toString();
    });
  }
}
